import React from "react";

function ResumeCandidate(props) {
  const { dataCandidateByID } = props;


  return (
    <div className="PDF-viewer" style={{ height: "60vh" }}>
      <iframe
        title="test PDF"
        // src={
        //   "file:///C:/Users/danang.winarso/Downloads/Jadwal%20Attire%20M-Titans%20per%209%20Mei%202022.pdf" +
        //   "#zoom=75"
        // }
        src={dataCandidateByID.link_cv + ".pdf" + "#zoom=75"}
        type="application/pdf"
        style={{ width: "100%", height: "100%" }}
      />
    </div>
  );
}

export default ResumeCandidate;
